import { getRandomInt } from "../helpers";
import { message } from "./message";
export function checkIntegrity() {
    const M = 60000;
    if ((process.env.TRIALPACKAGE || process.env.SITEPACKAGE) && isValid())
        return;
    setTimeout(() => {
        if (process.env.TRIALPACKAGE) {
            setInterval(() => {
                if (typeof window !== "undefined" &&
                    new Date() > process.env.TRIALDATE) {
                    //"Your trial has expired. Please purchase the commercial license for the Event Calendar widget at https://dhtmlx.com"
                    const str = window.atob("WW91ciB0cmlhbCBoYXMgZXhwaXJlZC4gUGxlYXNlIHB1cmNoYXNlIHRoZSBjb21tZXJjaWFsIGxpY2Vuc2UgZm9yIHRoZSBFdmVudCBDYWxlbmRhciB3aWRnZXQgYXQgaHR0cHM6Ly9kaHRtbHguY29t");
                    message(str);
                }
            }, getRandomInt(M, M * 3));
        }
        if (process.env.SITEPACKAGE) {
            setInterval(() => {
                //"This version of ToDo List is intended for demonstration only. Download an official evaluation version to try widget in your project at https://dhtmlx.com"
                const str = window.atob("VGhpcyB2ZXJzaW9uIG9mIEV2ZW50IENhbGVuZGFyIGlzIGludGVuZGVkIGZvciBkZW1vbnN0cmF0aW9uIG9ubHkuIERvd25sb2FkIGFuIG9mZmljaWFsIGV2YWx1YXRpb24gdmVyc2lvbiB0byB0cnkgd2lkZ2V0IGluIHlvdXIgcHJvamVjdCBhdCBodHRwczovL2RodG1seC5jb20=");
                message(str);
            }, getRandomInt(M, M * 3));
        }
    });
}
function isValid() {
    if (typeof window === "undefined")
        return true;
    const l = location.hostname;
    const t = [
        // dhtmlx.com
        "ZGh0bWx4LmNvbQ==",
        // dhtmlxcode.com
        "ZGh0bWx4Y29kZS5jb20=",
        // webixcode.com
        "d2ViaXhjb2RlLmNvbQ==",
        // webix.io
        "d2ViaXguaW8=",
        // repl.co
        "cmVwbC5jbw==",
        // csb.app
        "Y3NiLmFwcA==",
        // replit.dev
        "cmVwbGl0LmRldg==",
    ];
    for (let i = 0; i < t.length; i++) {
        const x = window.atob(t[i]);
        if (x === l || l.endsWith("." + x))
            return true;
    }
    return false;
}
//# sourceMappingURL=package.js.map